/* ============================================================
   TU Sticky Add-to-Cart bar engine — Avionlux (Horizon theme)
   Self-contained: data from /products/<handle>.js + the Kaching deal-bar in the page.
   The sticky button clicks the page's REAL Add-to-cart button (theme + Kaching add run unchanged).
   "Choose size/colour" scrolls to the product's own option controls and highlights them — rather than
   duplicating selectors, since the page's native colour picker and Kaching size bar reset each other.
   ============================================================ */
(function () {
  'use strict';
  var root = document.getElementById('tu-sticky-atc');
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!root || !form) return;

  var mediaEl  = root.querySelector('.tus__media');
  var titleEl  = root.querySelector('.tus__title');
  var variantEl = root.querySelector('.tus__variant');
  var priceEl  = root.querySelector('.tus__price');
  var btn      = root.querySelector('.tus__atc');
  var labelEl  = root.querySelector('.tus__label');
  var chooseBtn = root.querySelector('.tus__choose');

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { var p = (c / 100).toFixed(2).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return '$' + p.join('.'); }
  function realBtn() { return form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]'); }
  function curVid() { var i = form.querySelector('[name="id"]'); return i ? i.value : null; }

  // Brand: colour the sticky button to match the page's real Add-to-cart button.
  (function setAccent() {
    var rb = realBtn();
    if (rb) { var bg = getComputedStyle(rb).backgroundColor; if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') root.style.setProperty('--tus-accent', bg); }
  })();

  // ---- product data ----
  var P = null, vmap = {}, byId = {};
  var handle = (location.pathname.split('/products/')[1] || '').split('/')[0].split('?')[0];
  function loadProduct() {
    if (!handle) return Promise.resolve();
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        P = p;
        (p.variants || []).forEach(function (v) {
          vmap[v.id] = { price: v.price, cmp: v.compare_at_price, img: v.featured_image && v.featured_image.src, available: v.available };
          byId[v.id] = v;
        });
      }).catch(function () {});
  }

  // ---- Kaching bundle (deal-bar) reflection ----
  function selectedBar() {
    var bid = null, kp = document.querySelector('[name="properties[__kaching_bundles]"]');
    if (kp && kp.value) { try { var pj = JSON.parse(kp.value); bid = pj.bid || pj.bar; } catch (e) {} }
    var bar = bid ? document.querySelector('.kaching-bundles__bar[data-deal-bar-id="' + bid + '"]') : null;
    if (!bar) bar = document.querySelector('.kaching-bundles__bar--selected');
    return bar;
  }
  function barSize(bar) {
    if (!bar) return 0;
    var slots = bar.querySelectorAll('.kaching-bundles__collection-product, .kaching-bundles__bundle-products__product, .kaching-bundles__product').length;
    var t = (bar.querySelector('.kaching-bundles__bar-title') || {}).textContent || '';
    var m = t.match(/^\s*(\d+)\b/);
    return Math.max(slots, m ? parseInt(m[1], 10) : 0);
  }
  // Per-item colour/size of a multi-item bundle, e.g. "Midnight / M  ·  Dawn / L".
  function bundleVariantText(bar) {
    var rows = [].slice.call(bar.querySelectorAll('.kaching-bundles__bar-variant-selects'));
    return rows.map(function (r) {
      var sw = r.querySelector('.kaching-bundles__swatch-dropdown, [class*="swatch-dropdown"]');
      var sz = r.querySelector('select');
      var colour = sw ? (sw.getAttribute('data-value') || sw.textContent.replace(/\s+/g, ' ').trim()) : '';
      var size = sz ? sz.value : '';
      return [colour, size].filter(Boolean).join(' / ');
    }).filter(Boolean).join('  ·  ');
  }
  function barImages(bar) {
    var imgs = [].slice.call(bar.querySelectorAll('.kaching-bundles__collection-product img, .kaching-bundles__bundle-products img, .kaching-bundles__product img'));
    var srcs = imgs.map(function (im) { return im.getAttribute('src') || im.currentSrc; }).filter(Boolean);
    if (!srcs.length && P && P.featured_image) srcs = [P.featured_image];
    return srcs;
  }

  function setMedia(srcs) {
    srcs = (srcs || []).filter(Boolean);
    if (!srcs.length) { mediaEl.innerHTML = ''; return; }
    var shown = srcs.slice(0, 3), extra = srcs.length - shown.length;
    mediaEl.innerHTML = shown.map(function (s, i) { return '<img class="tus__img" src="' + esc(s) + '" alt="" loading="lazy" style="z-index:' + (10 - i) + '">'; }).join('')
      + (extra > 0 ? '<span class="tus__more">+' + extra + '</span>' : '');
    mediaEl.classList.toggle('tus__media--stack', srcs.length > 1);
  }

  // ---- "Choose size/colour": scroll to + highlight the product's own option controls ----
  function optionControls() {
    var list = [];
    var vp = document.querySelector('variant-picker'); if (vp) list.push(vp);
    var kw = document.querySelector('.kaching-bundles__bars') || document.querySelector('[class*="kaching-bundles__bar"]');
    if (kw) { var k = kw.closest('[class*="kaching-bundles"]') || kw; if (list.indexOf(k) < 0) list.push(k); }
    if (!list.length) { var rb = realBtn(); if (rb) list.push(rb.closest('form') || rb); }
    return list;
  }
  function hasChoices() {
    if (P && P.variants && P.variants.length > 1) return true;
    return !!document.querySelector('[class*="kaching-bundles__bar"]');
  }
  if (chooseBtn) chooseBtn.addEventListener('click', function () {
    var targets = optionControls(); if (!targets.length) return;
    var top = targets.reduce(function (a, b) { return a.getBoundingClientRect().top < b.getBoundingClientRect().top ? a : b; });
    try { top.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { top.scrollIntoView(); }
    targets.forEach(function (t) { t.classList.add('tus-hl'); setTimeout(function () { t.classList.remove('tus-hl'); }, 2000); });
  });

  // Mirror the real button's label + disabled state (kept live during a Kaching add).
  function mirrorBtn() {
    if (addLoading) return;            // don't fight the "Adding…" state
    var rb = realBtn(); if (!rb) return;
    var sp = rb.querySelector('span'); var txt = ((sp && sp.textContent) || rb.textContent || 'Add to cart').trim();
    if (labelEl && txt) labelEl.textContent = txt;
    btn.disabled = !!(rb.disabled || rb.getAttribute('aria-disabled') === 'true');
  }
  var btnObs = null, watchedBtn = null;
  function watchBtn() {
    var rb = realBtn(); if (!rb || rb === watchedBtn) return;
    if (btnObs) { try { btnObs.disconnect(); } catch (e) {} }
    watchedBtn = rb;
    if (!btnObs) btnObs = new MutationObserver(mirrorBtn);
    try { btnObs.observe(rb, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, subtree: true }); } catch (e) {}
  }

  function sync() {
    var bar = selectedBar();
    var multi = bar && barSize(bar) > 1;
    var vid = curVid(), bv = byId[vid], v = vmap[vid];
    // title
    if (multi) { var t = bar.querySelector('.kaching-bundles__bar-title'); titleEl.textContent = (t && t.textContent.trim()) || (P && P.title) || document.title; }
    else titleEl.textContent = (P && P.title) || document.title;
    // variant subtitle (colour/size) — single: the variant title; bundle: each item's colour/size
    if (variantEl) {
      if (multi) variantEl.textContent = bundleVariantText(bar);
      else variantEl.textContent = (bv && bv.title && bv.title !== 'Default Title') ? bv.title : '';
    }
    // price: the Kaching bar's deal/RRP when a bar is selected; else the plain variant price
    if (bar) {
      var dEl = bar.querySelector('.kaching-bundles__bar-price'), fEl = bar.querySelector('.kaching-bundles__bar-full-price');
      var deal = dEl ? dEl.textContent.trim() : '', full = fEl ? fEl.textContent.trim() : '';
      priceEl.innerHTML = (full && full !== deal ? '<s class="tus__was">' + esc(full) + '</s> ' : '') + (deal ? '<span class="tus__now">' + esc(deal) + '</span>' : '');
    } else if (v) {
      priceEl.innerHTML = (v.cmp && v.cmp > v.price ? '<s class="tus__was">' + money(v.cmp) + '</s> ' : '') + '<span class="tus__now">' + money(v.price) + '</span>';
    } else priceEl.textContent = '';
    // media
    if (multi) setMedia(barImages(bar));
    else setMedia([(v && v.img) || (P && P.featured_image)]);
    // button + reveal
    mirrorBtn(); watchBtn(); ensureAnchor();
    // "Choose size/colour" shown when the product actually has options to choose
    if (chooseBtn) chooseBtn.hidden = !hasChoices();
  }

  // ---- Reveal on scroll ----
  var io = null, anchorEl = null;
  function show(on) { root.classList.toggle('tus--show', on); root.setAttribute('aria-hidden', on ? 'false' : 'true'); }
  function ensureAnchor() {
    var a = realBtn() || form; if (!a || a === anchorEl) return;
    if (!('IntersectionObserver' in window)) { show(true); return; }
    if (io && anchorEl) { try { io.unobserve(anchorEl); } catch (e) {} }
    anchorEl = a;
    if (!io) io = new IntersectionObserver(function (ents) { ents.forEach(function (e) { if (e.target === anchorEl) show(!e.isIntersecting); }); }, { threshold: 0 });
    io.observe(anchorEl);
  }

  // Add to cart: the real button's add (especially a Kaching bundle) can take several seconds before
  // the cart drawer opens, so show an "Adding…" state immediately and clear it once the cart updates.
  var addLoading = false, addPoll = null, addTimer = null;
  function startAddLoading() {
    addLoading = true; btn.classList.add('tus__atc--loading');
    if (labelEl) labelEl.textContent = 'Adding…';
  }
  function stopAddLoading() {
    addLoading = false; btn.classList.remove('tus__atc--loading');
    if (addPoll) { clearInterval(addPoll); addPoll = null; }
    if (addTimer) { clearTimeout(addTimer); addTimer = null; }
    mirrorBtn();
  }
  // Horizon doesn't open its cart drawer until ~9s AFTER the (Kaching) add has already updated the cart.
  // We open it ourselves the instant the items land — the drawer's contents are already rendered by then,
  // so it appears immediately instead of after that dead gap.
  function cartDrawerOpen() { var d = document.querySelector('.cart-drawer__dialog'); return !!(d && (d.hasAttribute('open') || d.open) && d.getBoundingClientRect().width > 0); }
  function openCartDrawer() {
    if (cartDrawerOpen()) return;
    var ob = [].slice.call(document.querySelectorAll('button,a')).filter(function (b) { return /open cart/i.test(b.getAttribute('aria-label') || ''); })[0]
      || document.querySelector('[class*="header-actions__cart"] button, cart-icon button, cart-icon');
    if (ob) ob.click();
  }
  // The cart DATA updates (~8s) well before Horizon re-renders the drawer's contents (~17s), so the
  // freshly-opened drawer briefly shows "cart is empty". Cover it with a "Loading your cart…" overlay
  // until the real line items render (Horizon's re-render then replaces it, or we remove it ourselves).
  function drawerBody() { return document.querySelector('.cart-drawer__content') || document.querySelector('cart-drawer-component'); }
  function drawerHasItems() {
    var cd = document.querySelector('cart-drawer-component'); if (!cd) return false;
    var empty = [].slice.call(cd.querySelectorAll('*')).some(function (e) { return e.childElementCount === 0 && /cart is empty/i.test(e.textContent || '') && e.offsetParent !== null; });
    if (empty) return false;
    return [].slice.call(cd.querySelectorAll('[class*="cart-item"]')).some(function (e) { return e.offsetParent !== null; });
  }
  function showCartLoading() {
    var host = drawerBody(); if (!host || document.getElementById('tus-cart-loading')) return;
    try { if (getComputedStyle(host).position === 'static') host.style.position = 'relative'; } catch (e) {}
    var ov = document.createElement('div'); ov.id = 'tus-cart-loading'; ov.className = 'tus-cart-loading';
    ov.innerHTML = '<span class="tus-cart-loading__spin" aria-hidden="true"></span><span>Loading your cart…</span>';
    host.appendChild(ov);
  }
  function hideCartLoading() { var ov = document.getElementById('tus-cart-loading'); if (ov) ov.remove(); }

  var readyPoll = null;
  btn.addEventListener('click', function () {
    var rb = realBtn(); if (!rb || rb.disabled || addLoading) return;
    startAddLoading();
    var before = null;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { before = c.item_count; }).catch(function () {});
    rb.click();
    // when the cart count goes up the items have landed in the cart → open the drawer now
    addPoll = setInterval(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        if (before == null) { before = c.item_count; return; }
        if (c.item_count > before) {
          if (addPoll) { clearInterval(addPoll); addPoll = null; }
          openCartDrawer();
          stopAddLoading();                 // restore the sticky button (the drawer now has focus)
          // show "Loading your cart…" over the drawer until its contents actually render
          if (!drawerHasItems()) {
            showCartLoading();
            setTimeout(showCartLoading, 150);  // in case the drawer body mounts a tick later
            var t0 = Date.now();
            readyPoll = setInterval(function () {
              if (drawerHasItems() || Date.now() - t0 > 22000) { clearInterval(readyPoll); readyPoll = null; hideCartLoading(); }
            }, 300);
          }
        }
      }).catch(function () {});
    }, 400);
    addTimer = setTimeout(stopAddLoading, 25000); // safety net if the add never reports
  });

  // ---- triggers ----
  loadProduct().then(sync);
  sync();
  [400, 1200, 2500].forEach(function (ms) { setTimeout(sync, ms); });
  window.addEventListener('load', sync);
  var lastId = curVid();
  setInterval(function () { var v = curVid(); if (v !== lastId) { lastId = v; sync(); } }, 350);
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker, [class*="variant"], [class*="kaching"], form[action*="/cart/add"]')) setTimeout(sync, 60); }, true);
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[class*="kaching-bundles"]')) { setTimeout(sync, 60); setTimeout(sync, 350); } }, true);
})();
